import Head from 'next/head';
import Banner from '~/components/index/NewBanner/Banner';
import Footer from '~/components/Footer/Footer';
import BackTop from '~/components/BackTop/BackTop';

import css from './IndexLayout.less';

const React = require('react');

const { useEffect, useState } = React;

const Favicon = require('public/favicon.ico');

const LayoutIndex = props => {
  const { children } = props;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof navigator === 'undefined') {
      return;
    }
    const userAgent = navigator.userAgent || '';
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    setIsMobile(mobileRegex.test(userAgent));
  }, []);

  const viewportContent = isMobile
    ? 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover'
    : 'width=device-width, height=device-height';
  return (
    <div className={css.pageMain}>
      <Head>
        <meta name="viewport" content={viewportContent} />
        <meta name="renderer" content="webkit" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <link rel="shortcut icon" href={Favicon} type="image/x-icon" />
        <link rel="stylesheet" href="/style/desktop/reset.css" />
        <link rel="stylesheet" href="/style/desktop/common.css" />
        {isMobile && (
          <>
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="browsermode" content="application" />
            <meta name="full-screen" content="true" />
            <meta name="x5-fullscreen" content="true" />
            <meta name="360-fullscreen" content="true" />
          </>
        )}
      </Head>
      {/* banner container */}
      <Banner />
      <div className={css.content}>
        <div className={css.contentMain}>{children}</div>
      </div>
      {/* 页面公用底部组件 */}
      <Footer hasPartners />
      {/* 返回页面顶部组件 */}
      <BackTop />
    </div>
  );
};

export default LayoutIndex;
